import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {
  encrypted: any = "";
  decrypted: string = "";
  constructor() { }
  //The set method is use for encrypt the value.
  set(value: any) {
    const _secret: any = localStorage.getItem('tempKey');
    let _key = CryptoJS.enc.Utf8.parse(_secret);
    let _iv = CryptoJS.enc.Utf8.parse(_secret);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(value), _key, {
      keySize: 256,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    this.encrypted = encrypted.toString();
    return this.encrypted;
  }

  //The get method is use for decrypt the value.
  get(value: any) {
    const _secret: any = localStorage.getItem('tempKey');
    let _key = CryptoJS.enc.Utf8.parse(_secret);
    let _iv = CryptoJS.enc.Utf8.parse(_secret);
    try {
      this.decrypted = JSON.parse(CryptoJS.AES.decrypt(
        value, _key, {
        keySize: 256,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8));
      return this.decrypted;
    } catch (e) {
      return null;
    }
  }

  public generateRandom(length: number = 12, storageType: 'local' | 'session' = 'local', keyName: string = 'tempKey'): void {
    let result = '';
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }

    if (storageType === 'local') {
      localStorage.setItem(keyName, result);
    } else {
      sessionStorage.setItem(keyName, result);
    }
  }
}